import {
  Component,
  EventEmitter,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  SessionService,
  MessageService,
  CombosConfiguration,
  MenuBreadCrumb,
} from 'brainloper-ui';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { ProviderServiceService } from 'app/services/provider-service.service';
import { ModalTypesComponent } from '../../../../shared/modals-types/modal-types.component';
import { Provider } from 'app/models2/administration/provider';
@Component({
  selector: 'app-providers-detail',
  templateUrl: './providers-detail.component.html',
  styleUrls: ['./providers-detail.component.scss'],
})
export class ProvidersDetailComponent implements OnInit, OnChanges {
  public providersForm: UntypedFormGroup;

  public tipoRedireccion: string;

  private urlGetPaises: string = `${EndpointDictionary.Contry.COUNTRY_COMBO}`;
  private urlPostTerceros: string = `${EndpointDictionary.Provider.CRUD_PROVIDER_DATA}`;
  private urlGetRegion: string = `${EndpointDictionary.Region.REGION_COMBO}`;
  private urlGetCity: string = `${EndpointDictionary.City.CITY_COMBO}`;
  private urlGetProviderType: string = `${EndpointDictionary.ProviderType.PROVIDER_TYPE_COMBO}`;

  public reloadComboCountry = new EventEmitter<any>();
  public combosConfigCountry: CombosConfiguration = {
    visibleField: 'country',
    selectionField: 'id',
    urlCombo: this.urlGetPaises,
    label: 'Pais',
  };

  public reloadComboRegion = new EventEmitter<any>();
  public combosConfigRegion: CombosConfiguration = {
    visibleField: 'region',
    selectionField: 'id',
    label: 'Departamento',
  };

  public reloadComboCity = new EventEmitter<any>();
  public combosConfigCity: CombosConfiguration = {
    visibleField: 'city',
    selectionField: 'id',
    label: 'ciudad',
  };

  public reloadComboProviderType = new EventEmitter<any>();
  public combosProviderType: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetProviderType,
    label: 'Tipo de Proveedor',
  };
  private provider: Provider;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private message: MessageService,
    private router: Router,
    private session: SessionService,
    public dialog: MatDialog,
    public deleteItem: DeleteGenericService,
    public providerService: ProviderServiceService
  ) {
    this.providersForm = this.formBuilder.group({
      id: '',
      providerName: '',
      companyPhone: 0,
      countryId: 0,
      regionId: 0,
      cityId: 0,
      address: '',
      manager: '',
      identificationNumber: '',
      description: '',
      managePhone: 0,
      email: ['', [Validators.email]],
      sendEmail: 0,
      providerType: null,
    });
  }

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Terceros',
      router: '/administracion/terceros',
    },
    {
      name: 'Detalle',
      current: true,
    },
  ];

  ngOnInit() {
    this.message.openLoading('Cargando', 'Cargando');
    this.tipoRedireccion = this.session.getData('redireccion');
    if (this.tipoRedireccion == 'actualizar') {
      this.inicializarCampos();
    }
    if (this.tipoRedireccion == 'nuevo') {
      this.message.closeLoading();
    }

    this.providersForm.get('sendEmail')?.valueChanges.subscribe((value) => {
      const emailControl = this.providersForm.get('email');

      if (value === 1) {
        // Si se selecciona "Sí" en Enviar Correos
        emailControl?.setValidators([Validators.required, Validators.email]);
      } else {        
        emailControl?.clearValidators();
      }

      // Necesario para actualizar el estado del campo y activar/desactivar mensajes de error
      emailControl?.updateValueAndValidity();
    });
  }
  ngOnChanges(changes: SimpleChanges) {}

  inicializarCampos() {
    this.provider = this.session.getData('tercerosData');
    for (let datos of Object.keys(this.providersForm.controls)) {
      if (this.provider[datos] != null && this.provider[datos] != undefined) {
        this.providersForm.controls[datos].setValue(this.provider[datos]);
      }
    }
    this.combosProviderType.selected = this.provider.providerType;
    this.reloadComboProviderType.emit('selected');
    this.combosConfigCountry.selected = this.provider.countryId;
    this.providersForm.controls.providerType.setValue(
      this.provider.providerType
    );
    this.changesCountry(this.provider.countryId);
    this.changesRegion(this.provider.regionId);

    setTimeout(() => {
      this.message.closeLoading();
    }, 500);
  }

  changesCountry($event: number) {
    if ($event && $event > 0) {
      this.providersForm.controls.countryId.setValue($event);
      this.combosConfigRegion.urlCombo = `${this.urlGetRegion}/${$event}`;
      this.reloadComboRegion.emit();
      if (this.tipoRedireccion == 'actualizar') {
        this.combosConfigRegion.selected = this.provider.regionId;
      }
    }
  }

  changesRegion($event: number) {
    if ($event && $event > 0) {
      this.providersForm.controls.regionId.setValue($event);
      this.combosConfigCity.urlCombo = `${this.urlGetCity}/${$event}`;
      this.reloadComboCity.emit();
      if (this.tipoRedireccion == 'actualizar') {
        this.combosConfigCity.selected = this.provider.cityId;
      }
    }
  }

  ValueIDCity($event: number) {
    if ($event && $event > 0) {
      this.providersForm.controls.cityId.setValue($event);
    }
  }

  errorMessage() {
    this.message.Error('Error!', 'Debe completar los campos del formulario');
  }

  async saveProvider(form: Provider) {
    if (this.tipoRedireccion == 'actualizar') {
      await this.providerService.updateProvider(form);
    } else {
      delete form.id;
      await this.providerService.addProvider(form);
    }
  }

  // async eliminarTercero($event) {
  //   $event.preventDefault()
  //   let arrayDelete: Array<Provider> = []
  //   arrayDelete.push(this.provider)
  //   let res =  await this.deleteItem.deleteD(arrayDelete, this.urlPostTerceros, "id", "Tercero")
  //   if (res) {
  //     this.router.navigate(['administracion/terceros'])
  //   }
  // }

  addNew(type) {
    let size: number = screen.width > 500 ? 60 : 50;

    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: { name: type },
    });
  }

  back($event: PointerEvent) {
    $event.preventDefault();
    setTimeout(() => {
      this.router.navigate(['administracion/terceros']);
    }, 500);
  }
}
